import React, { FC } from 'react';
import { Checkbox, CheckboxType } from '@components/atoms/Checkbox';
import { ScrollArea } from '@components/atoms/ScrollArea';
import { Typography, TypographyAppearanceVariants } from '@components/atoms/Typography';

const MAX_CHARS_PER_OPTION_FOR_COMPACT_LAYOUT = 3;

export interface CheckboxFilterProps {
    title: string;
    options: { id: string; label: string | JSX.Element; value: string; checked?: boolean }[];
    onChange: (value: string) => void;
}

export const CheckboxFilter: FC<CheckboxFilterProps> = ({ title, options, onChange }) => {
    // if all options are strings and have a short amount of chars, options can be in a grid for a more compact layout
    const compact = options
        ?.map((item) => item.label)
        .every((item) => typeof item === 'string' && item.length <= MAX_CHARS_PER_OPTION_FOR_COMPACT_LAYOUT);

    return (
        <div className="pt-2">
            <Typography classes="mb-2" appearanceLevel={TypographyAppearanceVariants.level7}>
                {title}
            </Typography>
            <hr />
            <ScrollArea height="16.4em">
                <div className="row">
                    {options?.map((option, index) => {
                        return (
                            <div className={compact ? 'col-4' : 'col-12'} key={index}>
                                <Checkbox
                                    type={CheckboxType.blackVariant}
                                    id={option.id}
                                    name={option.id}
                                    value={option.value}
                                    label={option.label}
                                    checked={option.checked}
                                    onChange={(value: string) => onChange(value)}
                                />
                            </div>
                        );
                    })}
                </div>
            </ScrollArea>
        </div>
    );
};
